import axios from "axios";
import Config from "./Config";

export default {
  events: {
    auth_expired: [],
  },
  on: function (evtName, callback) {
    this.events[evtName].push(callback);
  },
  authKey: function () {
    return localStorage.getItem("auth_key");
  },
  register: function (email, password) {
    return new Promise((resolve, reject) =>
      axios
        .post(Config.GFU_API_URL + "/auth/register", {
          email,
          password,
          appKey: Config.API_KEY,
        })
        .then((response) => resolve(response))
        .catch((e) => reject(e))
    );
  },
  activate: function (activationToken) {
    return new Promise((resolve, reject) =>
      axios
        .get(Config.GFU_API_URL + "/auth/activate/" + activationToken)
        .then((response) => resolve(response.data))
        .catch((e) => reject(e))
    );
  },
  login: function (email, password) {
    return new Promise((resolve, reject) =>
      axios
        .post(Config.GFU_API_URL + "/auth/login", { email, password })
        .then((response) => {
          let token = response.data.token;
          localStorage.setItem("auth_key", response.data.id);
          localStorage.setItem("auth_token", token);
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          resolve(response);
        })
        .catch((e) => reject(e))
    );
  },
  logout: function () {
    if (!this.authKey()) {
      this.fireEvent("auth_expired");
      return false;
    }
    return new Promise((resolve, reject) =>
      axios
        .post(Config.GFU_API_URL + "/auth/logout")
        .then(() => {
          localStorage.removeItem("auth_key");
          localStorage.removeItem("auth_token");
          //delete axios.defaults.headers.common['Authorization']
          this.fireEvent("auth_expired");
          resolve();
        })
        .catch((e) => {
          if (e.response.status === 401) {
            localStorage.removeItem("auth_key");
            localStorage.removeItem("auth_token");
            this.fireEvent("auth_expired");
          } else {
            reject(e);
          }
        })
    );
  },
  fireEvent: function (evtName) {
    this.events[evtName].forEach((cb) => cb());
  },
  isLoggedIn: function () {
    if (localStorage.getItem("auth_token")) {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("auth_token")}`;
    }
    return localStorage.getItem("auth_key") ? true : false;
  },
};
